export default {
  START: 'start',
  CENTER: 'center',
  END: 'end',
};
